<template>
  <div>
    <!-- Silme Onay Popup -->
    <vs-popup
      class="holamundo"
      title="Cari Hesap Sil"
      :active.sync="deletePopupActive"
      v-esc="escape"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Cari Hesabı Silmek İstediğinize Emin misiniz?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteCariItem(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>

    <!-- Yeni Cari Ekle Butonu -->
    <vs-button @click="openAddModal" color="primary" type="filled" style="margin-top: 20px;">Yeni Cari Hesap Ekle</vs-button>

    <!-- Cari Hesapları Listeleme Tablosu -->
    <vs-table search :data="cariList">
      <template slot="header">
        <h3>
          Cari Hesaplar
        </h3>
      </template>
      <template slot="thead">
        <vs-th sort-key="name">
          Ad
        </vs-th>
        <vs-th sort-key="email">
          E-posta
        </vs-th>
        <vs-th sort-key="phone">
          Telefon
        </vs-th>
        <vs-th sort-key="address">
          Adres
        </vs-th>
        <vs-th>
          İşlemler
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].name">
            {{data[indextr].name}}
          </vs-td>
          <vs-td :data="data[indextr].email">
            {{data[indextr].email}}
          </vs-td>
          <vs-td :data="data[indextr].phone">
            {{data[indextr].phone}}
          </vs-td>
          <vs-td :data="data[indextr].address">
            {{data[indextr].address}}
          </vs-td>
          <vs-td>
            <feather-icon
              icon="EditIcon"
              svgClasses="w-5 h-5 hover:text-primary stroke-current"
              class="ml-2"
              @click.stop="
                editCari(tr)
              "
            />
            <feather-icon
              icon="TrashIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click.stop="
                deletedId = tr.id;
                deletePopupActive = true;
              "
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <!-- Ekleme/Düzenleme Modal -->
    <vs-popup class="holamundo" :title="isEditing ? 'Cari Hesap Düzenle' : 'Yeni Cari Hesap Ekle'" :active.sync="popupActive" @close="closePopup">
      <div class="con-form">
        <vs-input v-model="currentCari.name" label="Ad" class="mt-5 w-full" />
        <vs-input v-model="currentCari.email" label="E-posta" class="mt-5 w-full" />
        <vs-input v-model="currentCari.phone" label="Telefon" class="mt-5 w-full" />
        <vs-textarea v-model="currentCari.address" label="Adres" class="mt-5 w-full" />
        <vs-button @click="saveCari" color="primary" type="filled" style="margin-top: 20px;">Kaydet</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { getAllCari, getCariById, createCari, updateCari, deleteCari } from "@/api/Cari";

export default {
  data() {
    return {
      cariList: [],
      popupActive: false,
      deletedId: null,
      deletePopupActive: false,
      isEditing: false,
      currentCari: {
        id: null,
        name: '',
        email: '',
        phone: '',
        address: ''
      }
    }
  },
  created: async function () {
    await this.loadCariList();
  },
  methods: {
    async loadCariList() {
      try {
        const response = await getAllCari();
        this.cariList = response.data;
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Cari hesaplar yüklenirken bir hata oluştu!"
        });
      }
    },
    openAddModal() {
      this.currentCari = { id: null, name: '', email: '', phone: '', address: '' };
      this.isEditing = false;
      this.popupActive = true;
    },
    editCari(cari) {
      this.currentCari = {
        ...cari
      };
      this.isEditing = true;
      this.popupActive = true;
    },
    async saveCari() {
      try {
        if (this.isEditing) {
          await updateCari(this.currentCari);
        } else {
          await createCari(this.currentCari);
        }
        await this.loadCariList();
        this.popupActive = false;
        this.$vs.notify({
          color: "success",
          title: "Başarılı!",
          text: "Cari hesap başarıyla kaydedildi!"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Cari hesap kaydedilirken bir hata oluştu!"
        });
      }
    },
    async deleteCariItem(id) {
      try {
        await deleteCari(id);
        await this.loadCariList();
        this.deletePopupActive = false;
        this.$vs.notify({
          color: "success",
          title: "Başarılı!",
          text: "Cari hesap başarıyla silindi!"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Cari hesap silinirken bir hata oluştu!"
        });
      }
    },
    closePopup() {
      this.popupActive = false;
      this.currentCari = { id: null, name: '', email: '', phone: '', address: '' };
    },
    escape() {
      this.deletePopupActive = false;
      this.deletedId = null;
    }
  }
}
</script>

<style>
.con-form {
  width: 100%;
  padding: 20px;
}
</style>
